import { SiafLiteApiRepository } from "../../external";

class MonitorFinanceiroService {
  constructor() {
    this.urlBase = "financeiro/monitor-financeiro";
  }

  getDashboardKpis(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-kpis`,
    ).patch(body);
  }

  getDashboardEntradasSaidas(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-entradas-saidas`,
    ).patch(body);
  }

  getDashboardFluxoPrevisto(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-fluxo-previsto`,
    ).patch(body);
  }

  getDashboardRankingDespesas(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ranking-despesas`,
    ).patch(body);
  }

  getDashboardPrazosInadimplencia(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-prazos-inadimplencia`,
    ).patch(body);
  }

  getDashboardEntradasSaidasTotais(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-entradas-saidas-totais`,
    ).patch(body);
  }

  getDashboardRankingInadimplencia(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ranking-inadimplencia`,
    ).patch(body);
  }

  getDashboardDre(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-dre`,
    ).patch(body);
  }

  getDashboardCiclo(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ciclo`,
    ).patch(body);
  }
}

export default MonitorFinanceiroService;
